import React from 'react';
import { RefreshCw, FileText, Eye, Check, X } from 'lucide-react';

const STATUS_COLORS = {
  verified: 'text-green-700 bg-green-100',
  pending: 'text-yellow-700 bg-yellow-100',
  rejected: 'text-red-700 bg-red-100',
  declined: 'text-red-700 bg-red-100',
};

export const DocumentReviewSection = ({ documents, docsLoading, onReviewDocument }) => (
  <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-testid="documents-review-section">
    <div className="px-4 py-3 border-b border-white/10">
      <h3 className="text-white font-medium">Driver Document Review</h3>
      <p className="text-slate-500 text-xs mt-0.5">Review TWIC, Hazmat, and compliance documents submitted by drivers</p>
    </div>
    {docsLoading ? (
      <div className="flex items-center justify-center py-12">
        <RefreshCw className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    ) : documents.length === 0 ? (
      <div className="text-center py-12">
        <FileText className="h-10 w-10 text-slate-600 mx-auto mb-2" />
        <p className="text-slate-400 text-sm">No documents submitted yet</p>
      </div>
    ) : (
      <div className="divide-y divide-white/5">
        {documents.map((doc) => (
          <div key={doc.id} className="px-4 py-4 hover:bg-white/5 transition-colors" data-testid={`doc-review-${doc.id}`}>
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="w-9 h-9 rounded-lg bg-blue-500/10 flex items-center justify-center">
                  <FileText className="h-4 w-4 text-blue-400" />
                </div>
                <div className="min-w-0">
                  <p className="text-white text-sm font-medium">{doc.badge_type}</p>
                  <p className="text-slate-500 text-xs truncate">
                    {doc.user?.name || 'Unknown'} ({doc.user?.email || ''})
                  </p>
                  {doc.original_filename && <p className="text-slate-600 text-xs truncate">{doc.original_filename}</p>}
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`px-2 py-1 rounded-md text-xs font-medium ${STATUS_COLORS[doc.status] || 'text-yellow-700 bg-yellow-100'}`}>
                  {doc.status}
                </span>
                {doc.document_url && (
                  <a href={doc.document_url} target="_blank" rel="noopener noreferrer"
                    className="p-1.5 text-slate-400 hover:text-blue-400 rounded transition-colors" title="View document">
                    <Eye className="h-4 w-4" />
                  </a>
                )}
                {doc.status === 'pending' && (
                  <>
                    <button onClick={() => onReviewDocument(doc.id, 'verified')}
                      className="p-1.5 text-slate-400 hover:text-green-400 rounded transition-colors" title="Approve"
                      data-testid={`approve-doc-${doc.id}`}>
                      <Check className="h-4 w-4" />
                    </button>
                    <button onClick={() => onReviewDocument(doc.id, 'rejected')}
                      className="p-1.5 text-slate-400 hover:text-red-400 rounded transition-colors" title="Reject"
                      data-testid={`reject-doc-${doc.id}`}>
                      <X className="h-4 w-4" />
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
    <div className="px-4 py-3 border-t border-white/10 text-slate-400 text-xs">
      {documents.length} documents
    </div>
  </div>
);
